import * as React from "react";
import { Component } from "react";
import MainLayout from "../../layouts/MainLayout";
import Table from "../../components/Table";
import { __, getLocalized, getURLParam, mapStateToProps, setTableParams } from "../../core/utils";
import { createSuperadminSidebar } from "../../redux/actions/general/sidebar";
import { listActiveModules } from "../../redux/actions/general/active_modules";
import Tooltip from "../../components/Tooltip";
import * as _ from "lodash";
import { setPlusActions } from "../../redux/actions/general/plus";
import DeleteIcon from "../../assets/images/delete-15x15.svg";
import { hideAlertbox, showAlertbox } from "../../redux/actions/general/alertbox";
import { setNotification } from "../../redux/actions/general/notification";
import {
	deleteSpecificationSubgroups,
	listSpecificationSubgroups,
	readSpecificationSubgroup
} from "../../redux/actions/table/superadmin/specification_subgroups";
import SpecificationSubgroupsFlyout from "../../flyouts/superadmin/specification_subgroups/SpecificationSubgroupsFlyout";
import styles from "../../styles/views/superadmin/SpecificationSubgroups.scss";

@mapStateToProps(state => ({
	superadmin: state.auth.superadmin,
	table: state.table["superadmin_specification_subgroups"],
	application_language_id: state.auth.language_id,
}))
class SpecificationSubgroups extends Component {
	constructor(props) {
		super(props);

		this.state = {
			preview: null,
		};
	}

	componentDidMount() {
		listActiveModules();
		createSuperadminSidebar(); //don't forget to add new routes in sidebar.js

		const { superadmin } = this.props;

		superadmin.add_specification_subgroup && setPlusActions([{
			title: "Add specification subgroup",
			onClick: () => setTableParams('superadmin_specification_subgroups', {
				add_specification_subgroup_wizard: true
			})
		}]);
	}

	componentDidUpdate(prevProps) {
		if (this.props.table.clicked_row && this.props.table.clicked_row !== prevProps.table.clicked_row) {
			if (!prevProps.table.clicked_row) {
				this.setState({ preview: undefined });
			}

			readSpecificationSubgroup(this.props.table.clicked_row).then(({ response }) => {
				this.setState({ preview: response.data });
			});
		}
	}

	render() {
		const { superadmin, application_language_id } = this.props;

		const columns = [
			{
				key: "id",
				name: "ID",
				width: 60,
				sortable: false
			},
			{
				key: "name",
				name: "Name",
				value: name => getLocalized(name, application_language_id)
			},
			{
				key: "code",
				name: "Code",
				width: 60,
			},
			{
				key: "specification_group",
				name: "Specification Group",
				value: specification_group => getLocalized(specification_group, application_language_id),
				width: 150
			},
			{
				key: "boq_template_subgroup",
				name: "BOQ Template Subgroup",
				value: boq_template_subgroup => getLocalized(boq_template_subgroup, application_language_id),
				width: 150
			},
			{
				key: 'product_subgroups',
				name: 'Subgroups',
				width: 80,
				value: product_subgroups => {
					return <Tooltip text={_.join(_.map(product_subgroups, 'name'), "\n")}><span className={styles.chip}>{_.size(product_subgroups)}</span></Tooltip>
				}
			}
		];

		const singleActions = (specification_subgroup_id) => {
			return [
				<Tooltip text="Delete selected specification subgroup" key={_.uniqueId()}>
					<DeleteIcon
						onClick={e => {
							e.stopPropagation();

							showAlertbox({
								color: "red",
								title: __('general.alert.are-you-sure'),
								description: "Do you really want to delete the selected specification subgroup?\n\nThis process cannot be undone.",
								buttons: [
									{
										color: 'lightGray',
										text: __('general.alert.no-close'),
										onClick: 'close'
									},
									{
										color: 'gray',
										text: __('general.alert.yes-delete'),
										onClick: () => {
											deleteSpecificationSubgroups([specification_subgroup_id]).then(() => {
												hideAlertbox();

												setNotification("The selected specification subgroup has been deleted.");
												listSpecificationSubgroups();

												setTableParams('superadmin_specification_subgroups', {
													actioned_row: undefined
												});
											});
										},
									}
								]
							})
						}}
					/>
				</Tooltip>
			];
		};

		const groupActions = (specification_subgroups_ids) => [
			<Tooltip text="Delete selected specification subgroups" key={_.uniqueId()}>
				<DeleteIcon
					onClick={e => {
						e.stopPropagation();

						showAlertbox({
							color: "red",
							title: __('general.alert.are-you-sure'),
							description: "Do you really want to delete these specification subgroups?\n\nThis process cannot be undone.",
							buttons: [
								{
									color: 'lightGray',
									text: __('general.alert.no-close'),
									onClick: 'close'
								},
								{
									color: 'gray',
									text: __('general.alert.yes-delete'),
									onClick: () => {
										deleteSpecificationSubgroups(specification_subgroups_ids).then(() => {
											hideAlertbox();

											setNotification("The selected specification subgroups have been deleted.");
											listSpecificationSubgroups();

											setTableParams('superadmin_specification_subgroups', {
												selected_rows: []
											});
										});
									},
								}
							]
						})
					}}
				/>
			</Tooltip>
		];

		const preview = (
			<SpecificationSubgroupsFlyout
				data={this.state.preview}
				readAction={specification_subgroup_id => {
					return new Promise(resolve => {
						readSpecificationSubgroup(getURLParam('id') || specification_subgroup_id).then(({ response }) => {
							this.setState({ preview: response.data });

							resolve(response);
						});
					});
				}}
			/>
		);

		return (
			<Table
				listAction={listSpecificationSubgroups}
				name="superadmin_specification_subgroups"
				groupActions={superadmin.delete_specification_subgroup && groupActions}
				singleActions={superadmin.delete_specification_subgroup && singleActions}
				title={__("modules.submodules.title.specification-subgroups")}
				preview={this.state.preview ? preview : []}
				columns={columns}
			/>
		);
	}
}

export default SpecificationSubgroups;
